<!-- @format -->

<template>
	<v-container fill-height>
		<v-layout align-center justify-center>
			<v-flex xs12 sm8 md4>
				<v-card class="elevation-12">
					<v-toolbar dark color="#0d1b2a">
						<v-toolbar-title>{{ $t("Login.Login") }}</v-toolbar-title>
					</v-toolbar>
					<v-card-text>
						<v-form ref="form" v-model="valid">
							<v-alert
								v-model="snackbar"
								:color="snackbarColor"
								dismissible
								value
							>
								<strong>{{ snackbarMessage }}</strong>
							</v-alert>

							<v-text-field
								class="leftdirection"
								prepend-icon="person"
								name="username"
								v-bind:label="$t('Login.Username')"
								v-model="username"
								:rules="usernameRules"
								required
								data-cy="signinUsernameField"
							></v-text-field>
							<v-text-field
								class="leftdirection"
								:append-icon="visiblePassword ? 'mdi-eye' : 'mdi-eye-off'"
								prepend-icon="lock"
								name="password"
								v-bind:label="$t('Login.Password')"
								:type="visiblePassword ? 'text' : 'password'"
								v-model="password"
								:rules="passwordRules"
								required
								@click:append="visiblePassword = !visiblePassword"
							></v-text-field>
							<v-text-field
								class="leftdirection"
								prepend-icon="business"
								name="Domain"
								v-bind:label="$t('Login.Domain')"
								data-cy="signinDomainField"
								v-model="domain"
								:rules="domainRules"
								required
							></v-text-field>
							<div>
								<v-select
									class="leftdirection"
									v-model="select"
									:items="languageitems"
									@change="changeLocale(select.language, select.title)"
									prepend-icon="mdi-earth"
									item-text="title"
									item-value="language"
									label
									persistent-hint
									return-object
									single-line
								></v-select>
								<!-- <button
                  v-for="entry in languages"
                  :key="entry.title"
                  :click="changeLocale(entry.languages)"
                >
                  <flag :iso="entry.flag" v-bind:squared="false"></flag>
                  {{entry.title}}
                </button>-->
							</div>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-btn
							text
							@click="showResetDialog()"
							data-cy="signinSubmitBtn"
							id="ForGotPassword"
							color="#1A0DAB"
							>{{ $t("Login.ForGotPassword") }}</v-btn
						>
						<v-spacer></v-spacer>

						<v-btn
							color="#0d1b2a"
							dark
							@click="submit"
							data-cy="signinSubmitBtn"
							>{{ $t("Login.Login") }}</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-layout>
		<v-dialog v-model="resetDialog" max-width="300">
			<v-card class="mx-auto">
				<v-card-title class="resetCardtitle">
					<v-layout justify-center>
						<v-flex xs1 sm1 md1 xl1 lg1 class="px-0">
							<v-btn
								x-small
								icon
								dark
								color="white"
								@click="closeResetDialog()"
							>
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-flex>
						<v-flex xs11 sm11 md11 xl11 lg11 text-center>
							<span style="color: white; font-size: 1rem">{{
								$t("Login.ResetPassword")
							}}</span>
						</v-flex>
					</v-layout>
				</v-card-title>
				<v-card-text>
					<v-form ref="resetForm" v-model="resetFormValid">
						<v-container>
							<v-row>
								<v-text-field
									v-model="resetUsername"
									required
									:rules="usernameRules"
									v-bind:label="$t('Login.Username')"
								></v-text-field>
							</v-row>
							<v-row>
								<v-text-field
									name="Domain"
									v-bind:label="$t('Login.Domain')"
									v-model="resetDomain"
									:rules="domainRules"
									required
								></v-text-field>
							</v-row>
							<v-row class="pt-5">
								<v-btn
									height="40"
									dark
									color="#0d1b2a"
									@click="resetPassword()"
									>{{ $t("Login.Reset") }}</v-btn
								>
							</v-row>
						</v-container>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import cryptr from "../cryptr";
import publicMethod from "@/utility/publicMethod";

export default {
	name: "login",
	data() {
		return {
			resetFormValid: false,
			resetDialog: false,
			visiblePassword: false,
			color: null,
			snackbar: false,
			select: "",
			selectItem: "",
			message: null,
			fullPage: true,
			user: null,
			valid: false,
			username: "",
			password: "",
			domain: "",
			resetUsername: "",
			resetDomain: "",
			usernameRules: [
				(v) => !!v || this.$t("Login.UsernameRequired"),
				(v) =>
					!!v.match(/^[A-Za-z0-9!@#$%^&_=+-;<>.,'{}\[\]()]+$/) ||
					this.$t("Users.AllowedCharacterValid"),
			],
			passwordRules: [
				(v) => !!v || this.$t("Login.PasswordRequired"),
				(v) =>
					!!v.match(/^[A-Za-z0-9!@#$%^&_=+-;<>.,'{}\[\]()]+$/) ||
					this.$t("Users.AllowedCharacterValid"),
			],
			domainRules: [
				(v) => !!v || this.$t("Login.DomainRequired"),
				(v) =>
					!!v.match(/^[A-Za-z0-9!@#$%^&_=+-;<>.,'{}\[\]()]+$/) ||
					this.$t("Users.AllowedCharacterValid"),
			],
			usernameLabel: this.$t("Login.Username"),
			passwordLabel: this.$t("Login.Password"),
			domainLabel: this.$t("Login.Domain"),
			snackbarMessage: "",
			snackbarColor: "",
			// productList:[]
		};
	},
	computed: {
		languageitems() {
			return [
				{ title: this.$t("Login.English"), language: "en" },
				{ title: this.$t("Login.Persian"), language: "fa" },
				{ title: this.$t("Login.Turkish"), language: "tr" },
				{ title: "Deutsch", language: "de" },
			];
		},
	},
	mounted() {
		this.$store.dispatch("userLogout");
		if (
			window.$cookies.isKey("locale") &&
			window.$cookies.isKey("languageTitle")
		) {
			this.changeLocale(
				window.$cookies.get("locale"),
				window.$cookies.get("languageTitle"),
			);
			this.selectItem = {
				title: window.$cookies.get("languageTitle"),
				language: window.$cookies.get("locale"),
			};
			this.select = this.selectItem;
		} else {
			this.changeLocale("en", window.$cookies.get("languageTitle"));
			// this.selectItem = {
			// 	title: window.$cookies.get("languageTitle"),
			// 	language: window.$cookies.get("locale"),
			// };
			// 	this.select = this.selectItem;
			// this.selectItem = {
			//   title: this.$t("Login.English"),
			//   language: "en"
			// };
			// this.select = this.selectItem;
		}
		this.username = window.$cookies.isKey("username")
			? cryptr.decrypt(window.$cookies.get("username"))
			: "";
		this.password = window.$cookies.isKey("password")
			? cryptr.decrypt(window.$cookies.get("password"))
			: "";
		this.domain = window.$cookies.isKey("mydomain")
			? window.$cookies.get("mydomain")
			: "";
	},
	methods: {
		showResetDialog() {
			this.resetUsername = this.username;
			this.resetDomain = this.domain;
			this.resetDialog = true;
		},
		closeResetDialog() {
			this.resetDialog = false;
		},
		async resetPassword() {
			await this.$store.commit("setResetPasswordStatus", null);
			if (this.$refs.resetForm.validate()) {
				let loader = this.$loading.show({
					loader: "spinner",
					opacity: 0.5,
					zIndex: 999,
				});
				this.$store
					.dispatch("resetPassword", {
						username: this.resetUsername,
						domain: this.resetDomain,
					})
					.then(() => {
						this.$store.watch(
							(state) => state.resetPasswordStatus,
							(value) => {
								if (value != null) {
									let code = value.message.code;
									if (value.result == true) {
										this.snackbarColor = "green";

										this.snackbarMessage = this.$t("Login.UserInfoSendedSMS");
									} else {
										this.snackbarColor = "red";

										switch (code) {
											case "1":
												{
													this.snackbarMessage = this.$t(
														"Login.UsernameDomainNotFound",
													);

													// break;
												}
												break;
											case "2":
												{
													this.snackbarMessage = this.$t(
														"Login.InactiveOrganization",
													);
												}
												break;
											case "3":
												{
													this.snackbarMessage = this.$t(
														"Login.CloudModuleExpire",
													);
												}
												break;
											case "4":
												{
													this.snackbarMessage = this.$t(
														"Login.CompleteProfileInfo",
													);
												}
												break;
											case "5":
												{
													this.snackbarMessage = this.$t("Login.InactiveUser");
												}
												break;
											case "6":
												{
													this.snackbarMessage = this.$t("Login.ErrorSMS");
												}
												break;
										}
									}
									this.snackbar = true;
									loader.hide();
									this.resetDialog = false;
								}
							},
						);
					});
			}
		},
		changeLocale(locale, title) {
			if (locale == "fa") {
				this.$vuetify.rtl = true;
				this.$store.commit("setIsRight", true);
			} else {
				this.$vuetify.rtl = false;
				this.$store.commit("setIsRight", false);
			}
			this.$i18n.locale = locale;
			this.selectItem = { title: title, language: locale };
			this.select = this.selectItem;
			window.$cookies.set("locale", locale, "10d");
			window.$cookies.set("languageTitle", title, "10d");

			//Set Current Date
		},
		submit() {
			this.snackbarColor = "red";
			if (this.$refs.form.validate()) {
				let loader = this.$loading.show({
					loader: "spinner",
					opacity: 0.5,
					zIndex: 999,
				});
				this.$store
					.dispatch("userLogin", {
						username: this.username,
						password: this.password,
						domain: this.domain,
					})
					.then(() => {
						this.$store.watch(
							(state) => state.setUserInfo,
							(value) => {
								if (value != null) {
									loader.hide();
									this.message = value.message;
									if (value.result == true) {
										let cloudExpireDate = this.message.cloudBackupExpireDate;
										let diffrentDay = publicMethod.checkCloudExpiredDay(
											cloudExpireDate,
										);
										this.$store.commit("setCloudExpiredDay", diffrentDay);
										this.$store.commit("setIsAuthenticated", true);

										// console.info(this.$router);
										// console.info(this.$router.query);
										this.$router.push(
											this.$router.query
												? this.$router.query.redirect
												: "/dashboard",
										);
									} else {
										switch (this.message.code) {
											case 2: {
												this.snackbarMessage = this.$t(
													"Login.IncorrectUserAndPass",
												);
												this.snackbar = true;
												break;
											}
											case 3: {
												this.snackbarMessage = this.$t("Login.InactiveUser");
												this.snackbar = true;
												break;
											}
											case 4: {
												this.snackbarMessage = this.$t(
													"Login.InactiveOrganization",
												);
												this.snackbar = true;
												break;
											}
											case 5: {
												this.snackbarMessage = this.$t(
													"Login.InvalidOrganization",
												);
												this.snackbar = true;
												break;
											}
											case 6: {
												this.snackbarMessage = this.$t("Login.expireCloud");
												this.snackbar = true;
												break;
											}
										}
									}
								} else loader.hide();
							},
							{
								immediate: false,
							},
						);
					});
			}
		},
	},
};
</script>

<style scoped>
.leftdirection {
	direction: ltr;
}
.resetCardtitle {
	background-color: #0d1b2a;
}
#ForGotPassword {
	font-size: 12px;
}
</style>
